import G6 from '@antv/g6';
import insertCss from 'insert-css';
import 'xe-utils'
import {entityOaid, reportYear} from '../../util/util'
import 'vxe-table-quantdata/lib/style.css'
import httpManager from "../../util/common";


const formatTitle = function (title) {
  if (title == null || title == "")
    return ""
  if (title.length > 16)
    return title.substring(0, 15) + "..."
  return title
}
const COLLAPSE_ICON = function COLLAPSE_ICON(x, y, r) {
  return [
    ['M', x, y],
    ['a', r, r, 0, 1, 0, r * 2, 0],
    ['a', r, r, 0, 1, 0, -r * 2, 0],
    ['M', x + 2, y],
    ['L', x + 2 * r - 2, y],
  ]
}
const EXPAND_ICON = function EXPAND_ICON(x, y, r) {
  return [
    ['M', x, y],
    ['a', r, r, 0, 1, 0, r * 2, 0],
    ['a', r, r, 0, 1, 0, -r * 2, 0],
    ['M', x + 2, y],
    ['L', x + 2 * r - 2, y],
    ['M', x + r, y - r + 2],
    ['L', x + r, y + r - 2],
  ]
}
insertCss(`
  .g6-tooltip {
    border: 1px solid #e2e2e2
    border-radius: 4px
    font-size: 12px
    color: #545454
    background-color: rgba(255, 255, 255, 0.9)
    padding: 10px 8px
    box-shadow: rgb(174, 174, 174) 0px 0px 10px
  }
`)
G6.registerNode(
  'card-node',
  {
    drawShape: function drawShape(cfg, group) {
      const color = cfg.has_stock != '1' || cfg.trade_rate == null ? '#FFFFFF' :  cfg.trade_rate >= 0 ? '#A72D2D' : '#4C964B'
      let anchorHeight = 45
      if (cfg.type == 'anchor') {
        let len = cfg.panels.length
        anchorHeight = 45 + len * 14
      }
      const r = 2
      const shape = group.addShape('rect', {
        attrs: {
          x: 0,
          y: 0,
          width: 260,
          height: anchorHeight,
          stroke: color=='#FFFFFF'?'black':color,
          fill: color,
          radius: r,
          cursor: 'pointer'
        },
        name: 'main-box',
        draggable: true,
      })
      group.addShape('rect', {
        attrs: {
          x: 0,
          y: 0,
          width: 260,
          height: 25,
          fill: color,
          position: 'center',
          radius: [r, r, 0, 0],
          cursor: 'pointer'
        },
        name: 'title-box',
        draggable: true,
      })
      if (cfg.has_stock == '1') {
        group.addShape('image', {
          attrs: {
            x: 215,
            y: 2,
            height: 15,
            width: 15,
            cursor: 'pointer',
            img: color=='#FFFFFF'?'/static/images/ticker.png':'/static/images/ticker-nega.png',
          },
          name: 'stock-node-icon',
        })
      }
      if (cfg.has_bond == '1') {
        group.addShape('image', {
          attrs: {
            x: 235,
            y: 2,
            height: 15,
            width: 15,
            cursor: 'pointer',
            img: color=='#FFFFFF'?'/static/images/bond.png':'/static/images/bond-nega.png',
            backgroundColor: '#FFF'
          },
          name: 'bond-node-icon',
        })
      }
      // title text
      group.addShape('text', {
        attrs: {
          textBaseline: 'top',
          y: 5,
          x: 12,
          lineHeight: 20,
          width: 190,
          text: formatTitle(cfg.title),
          stroke: color,
          fill: color=='#FFFFFF'?'black':'white',
          cursor: 'pointer'
        },
        name: 'title'
      })
      // The content list
      cfg.panels.forEach((item, index) => {
        // name text
        group.addShape('text', {
          attrs: {
            textBaseline: 'top',
            y: 25 + index * 17,
            x: 12,
            lineHeight: 20,
            text: item.title,
            fontSize: 10,
            fill: color=='#FFFFFF'?'black':'white',
            cursor: 'pointer'
          },
          name: `index-title-${index}`
        })
      })
      return shape
    },
  },
  'single-node'
)
let vm = {
  delimiters: ['{', '}'],

  data: () => {
    return {
      oaid: null,
      report: reportYear.report_year_now,
      reportRaw: reportYear.report_years,
      duration: 5,
      reports: reportYear.report_options,
      relate: null,
      graphType: false,
      graph: null,
      divloading: false
    }
  },
  methods: {
    getOaid(){
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid =result
        self.getESGData()
      })
    },
    getESGData() {
      let self = this
      self.divloading = true
      let params = new Map()
      params.set('oaid', self.oaid)
      if (self.relate) {
        params.set('relate', self.relate)
      }
      let reports = reportYear.getReport(self.report, self.duration)
      params.set('years', reports)
      if (self.graph != null) {
        self.graph.clear()
      }
      httpManager('supply_chain_periodic_tree_graph', params)
        .then(response => {
          let data = response.data
          console.log(data);
          self.drawGraph(data, 'graph')
          self.divloading = false
        })
        .catch(error => {
          console.log(error)
          if (self.graph != null) {
            self.graph.clear()
          }
          self.divloading = false
        })
    },
    selectGraph(value) {
      let self = this
      if (self.chart_type == 'all') {
        self.graphType = false
      } else {
        self.graphType = true
      }
    },
    drawGraph(data, container) {

      let s_nodes = data['supplier_num'] + 1
      let c_nodes = data['customer_num'] + 1
      let h = Math.max(s_nodes * 80, c_nodes * 80) + 30
      let height = ((c_nodes+s_nodes)>2?Math.max(1000, h):150)/20*getComputedStyle(window.document.documentElement)['font-size'].slice(0, 2)
      // console.log();
      let width = ((c_nodes+s_nodes)>2?1400:400)/20*getComputedStyle(window.document.documentElement)['font-size'].slice(0, 2)
      let self = this
      if (self.graph == null) {
        self.graph = new G6.TreeGraph({
          container: container,
          width: width,
          height: height,
          modes: {
            default: [
              {
                type: 'collapse-expand',
                onChange: function onChange(item, collapsed) {
                  const data = item.get('model').data
                  data.collapsed = collapsed
                  return true
                },
              },
              // 'drag-canvas',
              // 'zoom-canvas',
              'drag-node',
              // {
              //   type: 'tooltip',
              //   formatText: function formatText(model) {
              //     let html = "<div style='height: 20px'>{official-name}</div><div class='my-tooltip'>" +
              //       "<table border=\"1\"><thead><tr><th>上市实体</th><th>深度</th><th>持股比例</th><th>代码</th><th>简称</th><th>涨幅</th></tr></thead><tbody>{tbody-stock}</tbody></table>" +
              //       "<div style='height: 10px'></div>" +
              //       "<table border=\"1\"><thead><tr><th>发债实体</th><th>深度</th><th>持股比例</th><th>银行间债数</th><th>交易所债数</th><th>存续数</th></tr></thead><tbody>{tbody-bond}</tbody></table></div>"
              //     html = html.replace("{official-name}", model.title)
              //     let tr = "<tr>{tr}</tr>\n"
              //     let td = "<td>{td}</td>"
              //     let bodyStock = ""
              //     for (let i in model.securities) {
              //       let security = model.securities[i]
              //       bodyStock += tr.replace("{tr}",
              //         td.replace("{td}", security.official_name != null ? security.official_name : "") +
              //         td.replace("{td}", security.equity_grade != null ? security.equity_grade : "") +
              //         td.replace("{td}", security.summary_fundedratio != null ? security.summary_fundedratio.toFixed(2) + "%" : "") +
              //         td.replace("{td}", security.ticker != null ? security.ticker : "") +
              //         td.replace("{td}", security.short_name != null ? security.short_name : "") +
              //         td.replace("{td}", security.trade_rate != null & security.trade_rate != 'None' ? security.trade_rate + "%" : ""))
              //     }
              //     html = html.replace("{tbody-stock}", bodyStock)
              //     let bodyBond = ""
              //     for (let i in model.bonds) {
              //       let bond = model.bonds[i]
              //       bodyBond += tr.replace("{tr}",
              //         td.replace("{td}", bond.official_name != null ? bond.official_name : "") +
              //
              //         td.replace("{td}", bond.equity_grade != null ? bond.equity_grade : "") +
              //         td.replace("{td}", bond.summary_fundedratio != null ? bond.summary_fundedratio.toFixed(2) + "%" : "") +
              //         td.replace("{td}", bond.ib_total != null & bond.ib_total != 'None' ? bond.ib_total : "") +
              //         td.replace("{td}", bond.exc_total != null & bond.exc_total != 'None' ? bond.exc_total : "") +
              //         td.replace("{td}", bond.existence_total != null & bond.existence_total != 'None' ? bond.existence_total : ""))
              //     }
              //
              //     return html.replace("{tbody-bond}", bodyBond)
              //   },
              //
              //   shouldUpdate: (e) => {
              //     if (e.target.get('name') === 'stock-node-icon' ||
              //       e.target.get('name') === 'bond-node-icon') {
              //       const div = document.getElementsByClassName('g6-tooltip')[0]
              //       if (div) div.style.display = 'block'
              //       return true
              //     }
              //     return false
              //   }
              // }
            ],
          },
          defaultNode: {
            shape: 'card-node',
            anchorPoints: [
              [0, 0.5],
              [1, 0.5],
            ],
          },
          defaultEdge: {

            type: 'cubic-horizontal',
            style: {
              stroke: '#A3B1BF'
            },

          },
          fitView: true,
          layout: {
            type: 'indented',
            direction: 'H',
            indent: 80,
            getHeight: () => {
              return 50
            },
            getWidth: () => {
              return 280
            },
            getVGap: () => {
              return 10
            },
            getHGap: () => {
              return 100
            },
            getSide: d => {
              if (d.data.col === 1) {
                return 'left'
              }
              if (d.data.col === 5) {
                return 'right'
              }
              return 'right'
            },
          },
        })

        let centerX = 3
        self.graph.node(function (node) {
          return {
            // label: node.title,
            labelCfg: {
              position: node.col > centerX ? 'right' : 'left',
              offset: 5,
            },
          }
        })
        self.graph.on('node:click', function (event) {
          const {currentTarget, item} = event
          let type_sc = item._cfg.model.type
          if (type_sc === 'anchor') {
            return
          }
          let id = item._cfg.id.substring(0, 36)
          if(!id || id =='None_c'|| id == 'None_s'){
            return
          }
          const {href} = self.$router.resolve({path:  '/entity/'+id+'/home'})
          window.open(href, '_blank')
        })
      }
      self.graph.changeSize(width, height)
      self.graph.data(data)
      self.graph.render()
      self.graph.fitView()
      // self.graph.refreshLayout(true)
    }
  },
  mounted() {
    this.getOaid()
  },
  watch: {
    report: function () {
      this.getESGData()
    },
    duration: function () {
      this.getESGData()
    },
    relate: function () {
      this.getESGData()
    },
  }

}

export default vm



// WEBPACK FOOTER //
// ./src/supplychain/js/supply_chain_graph.js